import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { AvaliacaoDeficiente } from '../models/avaliacao-deficiente.model';

@Injectable()
export class AvaliacaoDeficienteService {

  constructor(private httpClient: HttpClient) { }

  GetAvaliacaoDeficiente(numeroConcurso: number, id: number): Observable<AvaliacaoDeficiente> {
    return this.httpClient.get<AvaliacaoDeficiente>(`/Avaliacao/GetAvaliacaoDeficiente/${numeroConcurso}/${id}`);
  }

  Create(avaliacao: AvaliacaoDeficiente): Observable<AvaliacaoDeficiente> {
    return this.httpClient.post<AvaliacaoDeficiente>(`Avaliacao/PostAvaliacaoDef/`, avaliacao);
  }

}




// WEBPACK FOOTER //
// ./src/app/services/avaliacao-deficiente.service.ts